import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { CASH_REGISTER_REPORT_ENDPOINT } from '../endpoint';
import { CashRegisterReportRequestModel } from '../models/CashRegisterReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: CashRegisterReportRequestModel): Promise<void> => {
    return await axios
      .get(`${CASH_REGISTER_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'cash-register-report',
        });
      });
  };
